import { computed, ComputedRef } from 'vue'
import { useStore } from 'vuex'

import { PageType } from '@/domain/value_objects/frame/PageType'
import { FrameStateModuleName } from '@/store/modules/modules'

export class FrameStateViewModel {
  private store = useStore()

  leftSideFrame: ComputedRef<PageType> = computed(() => this.store.getters[`${FrameStateModuleName}/leftSideFrame`])
  rightSideFrame: ComputedRef<PageType> = computed(() => this.store.getters[`${FrameStateModuleName}/rightSideFrame`])
  isHandlingSlideBar: ComputedRef<boolean> = computed(
    () => this.store.getters[`${FrameStateModuleName}/isHandlingSlideBar`]
  )
  minLeftSideFrameWidth: ComputedRef<number> = computed(
    () => this.store.getters[`${FrameStateModuleName}/minLeftSideFrameWidth`]
  )
  maxLeftSideFrameWidth: ComputedRef<number> = computed(
    () => this.store.getters[`${FrameStateModuleName}/maxLeftSideFrameWidth`]
  )
  leftSideFrameWidth: ComputedRef<number> = computed(
    () => this.store.getters[`${FrameStateModuleName}/leftSideFrameWidth`]
  )

  setLeftSideFrame(leftSideFrame: PageType): void {
    this.store.commit(`${FrameStateModuleName}/setLeftSideFrame`, { leftSideFrame })
  }

  setRightSideFrame(rightSideFrame: PageType): void {
    this.store.commit(`${FrameStateModuleName}/setRightSideFrame`, { rightSideFrame })
  }

  setIsHandlingSlideBar(flag: boolean): void {
    this.store.commit(`${FrameStateModuleName}/setIsHandlingSlideBar`, { flag })
  }

  setLeftSideFrameWidth(width: number): void {
    this.store.commit(`${FrameStateModuleName}/setLeftSideFrameWidth`, { width })
  }

  setMaxLeftSideFrameWidth(width: number): void {
    this.store.commit(`${FrameStateModuleName}/setMaxLeftSideFrameWidth`, { width })
  }
}
